__turbopack_context__.v({
  "bottom": "IconButton-module-scss-module__B0EJgG__bottom",
  "l": "IconButton-module-scss-module__B0EJgG__l",
  "left": "IconButton-module-scss-module__B0EJgG__left",
  "m": "IconButton-module-scss-module__B0EJgG__m",
  "right": "IconButton-module-scss-module__B0EJgG__right",
  "s": "IconButton-module-scss-module__B0EJgG__s",
  "top": "IconButton-module-scss-module__B0EJgG__top",
});
